export default "__VITE_ASSET__BtBE8Exe__"